import React, { useCallback, useMemo } from "react";
import {
    callConfigurationDesktopStyles,
    callConfigurationMobileStyles,
    callDetailsContainerStylesDesktop,
    callDetailsStyleDesktop,
    callDetailsStyleMobile,
    cameraPermissionGrantedTrampoline,
    configurationPageContainerStyleDesktop,
    configurationPageContainerStyleMobile,
    configurationPageContentStyleDesktop,
    configurationPageContentStyleMobile,
    configurationPageStyle,
    configurationStackTokensMobile,
    DeviceCheckOptions,
    LocalDeviceSettings,
    localPreviewDesktopOneColumnStyle,
    localPreviewDesktopStyle,
    localPreviewTrampoline,
    MEDIUM_SCREEN_BREAKPOINT,
    micPermissionGrantedTrampoline,
    selectionContainerDesktopOneColumnLayoutStyle,
    selectionContainerDesktopStyle,
    StartCallButton,
    startCallButtonContainerStyleDesktop,
    startCallButtonContainerStyleMobile,
    startCallButtonStyleMobile,
    titleContainerStyleDesktop,
    titleContainerStyleMobile,
    TopToolbar,
    useCommonConfigurationPageHandlers,
    useHandlers,
} from "live-lesson/shared/feature-call-ui-react";
import { mergeStyles, Stack } from "@fluentui/react";
import { ActiveErrorMessage } from "@azure/communication-react";
import { Subtitle2 } from "@fluentui/react-components";
import { useMediaQuery } from "@uidotdev/usehooks";


export interface ConfigurationPageProps {
    mobileView: boolean;
    startCallHandler(): void;
    latestErrors: ActiveErrorMessage[];
    onDismissError: (error: ActiveErrorMessage) => void;
    deviceChecks?: DeviceCheckOptions;
    onPermissionsTroubleshootingClick?: (permissionsState: {
        camera: PermissionState;
        microphone: PermissionState;
    }) => void;
    onNetworkingTroubleShootingClick?: () => void;
}


export const ConfigurationPage = (props: ConfigurationPageProps): JSX.Element => {
    const {
        startCallHandler,
        mobileView,
        deviceChecks,
        onPermissionsTroubleshootingClick,
        onNetworkingTroubleShootingClick,
        latestErrors,
    } = props;

    const localDeviceSettingsHandlers = useHandlers(LocalDeviceSettings);

    const {
        microphonePermissionGranted,
        options,
        cameraPermissionGranted,
        role,
        videoState,
        audioState,
        setIsPermissionsModalDismissed,
        disableStartCallButton,
    } = useCommonConfigurationPageHandlers({ deviceChecks, latestErrors });

    // const locale = useLocale();
    const title = (
        <Stack.Item
            className={mobileView ? titleContainerStyleMobile : titleContainerStyleDesktop}
            role="heading"
            aria-level={1}
        >
            {/*{locale.strings.call.configurationPageTitle}*/}
            Configuration
        </Stack.Item>
    );

    const callDescription = (
        <Stack.Item className={mobileView ? callDetailsStyleMobile : callDetailsStyleDesktop}>
            {/*{locale.strings.call.configurationPageCallDetails}*/}
            <Subtitle2 style={{fontWeight: 400}}>Überprüfen Sie die Bild- und Tonwiedergabe</Subtitle2>
        </Stack.Item>
    );

    const isNarrowScreen = useMediaQuery(`(max-width: ${MEDIUM_SCREEN_BREAKPOINT})`);
    let mobileWithPreview = mobileView;
    mobileWithPreview = mobileWithPreview && role !== 'Consumer';
    const oneColumnLayout = mobileView && role !== 'Consumer' || isNarrowScreen;

    const configurationPageContentStyles = useMemo(() =>
        mobileWithPreview || oneColumnLayout ? callConfigurationMobileStyles.root : callConfigurationDesktopStyles.root,
    [oneColumnLayout, mobileWithPreview]);

    const selectionContainerStyles = useMemo( () => mobileView ? undefined :
        oneColumnLayout ? selectionContainerDesktopOneColumnLayoutStyle
            : selectionContainerDesktopStyle,
    [oneColumnLayout, mobileView]);

    const startCall = useCallback(async () => {
        startCallHandler();
    }, [startCallHandler]);

    return (<>
        <div className={configurationPageStyle}>
            {!mobileView && <TopToolbar></TopToolbar>}
            <Stack data-ui-id="config-page-container" className={mobileView ? configurationPageContainerStyleMobile : configurationPageContainerStyleDesktop}>


                {/*<Stack styles={bannerNotificationStyles}>*/}
                {/*    <ConfigurationPageErrorBar*/}
                {/*        // show trouble shooting error bar when encountering network error/ permission error*/}
                {/*        showTroubleShootingErrorBar={*/}
                {/*            !cameraPermissionGranted || !microphonePermissionGranted || networkErrors.length > 0*/}
                {/*        }*/}
                {/*        permissionsState={permissionsState}*/}
                {/*        onNetworkingTroubleShootingClick={onNetworkingTroubleShootingClick}*/}
                {/*        onPermissionsTroubleshootingClick={onPermissionsTroubleshootingClick}*/}
                {/*        errorBarProps={filteredErrorBarProps}*/}
                {/*        onDismissError={props.onDismissError}*/}
                {/*    />*/}
                {/*</Stack>*/}
                {
                    /* @conditional-compile-remove(call-readiness) */
                //     // show the following screen if permission API is availible (not unsupported) and videoState, audioState is assigned values
                //     videoState && videoState !== 'unsupported' && audioState && audioState !== 'unsupported' && (
                //         <CallReadinessModal
                //             modalLayerHostId={modalLayerHostId}
                //             mobileView={mobileView}
                //             /* @conditional-compile-remove(unsupported-browser) */
                //             environmentInfo={environmentInfo}
                //             permissionsState={permissionsState}
                //             isPermissionsModalDismissed={isPermissionsModalDismissed}
                //             setIsPermissionsModalDismissed={setIsPermissionsModalDismissed}
                //             onPermissionsTroubleshootingClick={onPermissionsTroubleshootingClick}
                //         />
                //     )
                // }

                // {
                //     /* @conditional-compile-remove(call-readiness) */
                //     // show the following screen if permission API is not availible (unsupported) and videoState, audioState is assigned values
                //     videoState && audioState && (videoState === 'unsupported' || audioState === 'unsupported') && (
                //         <CallReadinessModalFallBack
                //             /* @conditional-compile-remove(call-readiness) */
                //             modalLayerHostId={modalLayerHostId}
                //             mobileView={mobileView}
                //             checkPermissionModalShowing={forceShowingCheckPermissions}
                //             permissionsState={permissionsState}
                //             isPermissionsModalDismissed={isPermissionsModalDismissed}
                //             /* @conditional-compile-remove(unsupported-browser) */
                //             // environmentInfo={environmentInfo}
                //             setIsPermissionsModalDismissed={setIsPermissionsModalDismissed}
                //             onPermissionsTroubleshootingClick={onPermissionsTroubleshootingClick}
                //         />
                //     )
                // }

                <Stack grow horizontal className={mobileView ? configurationPageContentStyleMobile : configurationPageContentStyleDesktop}>
                    <Stack
                        className={mergeStyles(configurationPageContentStyles)}
                        horizontal={!oneColumnLayout}
                        horizontalAlign={oneColumnLayout ? 'stretch' : 'center'}
                        verticalAlign="center"
                        tokens={oneColumnLayout ? configurationStackTokensMobile : undefined}
                    >
                        {mobileWithPreview && (
                            <Stack.Item>
                                {title}
                                {callDescription}
                            </Stack.Item>
                        )}
                        {/*{localPreviewTrampoline(mobileWithPreview, !!(role === 'Consumer'))}*/}
                        {localPreviewTrampoline(mobileWithPreview, false, oneColumnLayout ? localPreviewDesktopOneColumnStyle : localPreviewDesktopStyle)}
                        <Stack className={selectionContainerStyles} >
                            {!mobileWithPreview && (
                                <>
                                    <Stack.Item styles={callDetailsContainerStylesDesktop}>
                                        {callDescription}
                                    </Stack.Item>
                                </>
                            )}

                            <LocalDeviceSettings
                                {...options}
                                {...localDeviceSettingsHandlers}
                                cameraPermissionGranted={cameraPermissionGrantedTrampoline(
                                    cameraPermissionGranted,
                                    videoState,
                                )}
                                microphonePermissionGranted={micPermissionGrantedTrampoline(
                                    microphonePermissionGranted,
                                    audioState
                                )}
                                onClickEnableDevicePermission={() => {
                                    setIsPermissionsModalDismissed(true);
                                }}
                                isMobile={mobileView}
                            />

                            <Stack
                                styles={mobileWithPreview ? startCallButtonContainerStyleMobile : startCallButtonContainerStyleDesktop}
                            >
                                <StartCallButton
                                    className={mobileWithPreview ? startCallButtonStyleMobile : undefined}
                                    isModerator={true}
                                    onClick={startCall}
                                    disabled={disableStartCallButton}
                                />
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>}
            </Stack>
        </div>
    </>);
};
